import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionIcon,
  AccordionPanel,
  Box,
} from '@chakra-ui/react'

import { Layout } from 'src/components/Layout'
import SvgIcon from 'src/components/SvgIcon'
import PolicyItemDisplayValue from 'src/modules/Documents/PolicySummaryView/PolicyItemDisplayValue'
import '../styles.module.less'
import styles from './styles.module.less'
import intlMessages from '../translations'

const PolicyItem = ({ policy, item, intl, history }) => {
  // Redirect to documents if policy not found
  if (!policy && history) {
    history.push('/documents')
    return false
  }

  const personType =
    policy.category === 'auto'
      ? intl.formatMessage(intlMessages.policyDriver)
      : policy.category === 'property'
      ? intl.formatMessage(intlMessages.policyInsurer)
      : null

  return (
    <Layout className={styles.policyItem}>
      <div className={styles.policyItemCard}>
        <PolicyItemDisplayValue policy={policy} item={item} />

        {item.hasOwnProperty('policyPeople') && item.policyPeople.length > 0 ? (
          <div className={styles.itemRow + ' ' + styles.itemRowPeople}>
            <div className={styles.policyPeople}>
              {item.policyPeople.map((person, key) => {
                return (
                  <div key={key} className={styles.itemRow + ' ' + styles.personRow}>
                    <div className={styles.itemIconHolder}>
                      <SvgIcon type='Person' className={styles.itemIcon} />
                    </div>
                    <div>
                      <div className={styles.itemLabel}>{personType || ''}</div>
                      <div className={styles.itemValue}>{person.name || ''}</div>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        ) : (
          ''
        )}

        {item.hasOwnProperty('coverages') && item.coverages.length > 0 ? (
          <div className={styles.policyCoverages}>
            <Accordion allowToggle>
              <AccordionItem className={styles.policyAccordionItem}>
                <h2>
                  <AccordionButton
                    pl='0'
                    pr='0'
                    className={styles.policyAccordionBtn}
                    _focusVisible={{
                      border: '2px solid',
                      borderColor: 'black',
                    }}
                  >
                    <Box
                      as='span'
                      flex='1'
                      textAlign='left'
                      className={styles.policyCoveragesHeader}
                    >
                      {intl.formatMessage(intlMessages.policyCoverageDetails)}:
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel pl='0' pr='0' pb='0'>
                  {item.coverages.map((coverage, key) => (
                    <div key={key} className={styles.listItem + ' ' + styles.coverageItem}>
                      <div
                        className={
                          styles.listItemCol + ' ' + styles.listValue + ' ' + styles.coverageCheck
                        }
                      >
                        <SvgIcon type='CheckSimple' className={styles.coverageIcon} />
                      </div>
                      <div className={styles.listItemCol + ' ' + styles.listLabel}>{coverage}</div>
                    </div>
                  ))}
                </AccordionPanel>
              </AccordionItem>
            </Accordion>
          </div>
        ) : (
          ''
        )}
      </div>
    </Layout>
  )
}

PolicyItem.propTypes = {
  item: PropTypes.object.isRequired,
}

export default injectIntl(PolicyItem)
